import { render, staticRenderFns } from "./SquareWithIcon.vue?vue&type=template&id=987a9ad2"
import script from "./SquareWithIcon.vue?vue&type=script&lang=js"
export * from "./SquareWithIcon.vue?vue&type=script&lang=js"
import style0 from "./SquareWithIcon.vue?vue&type=style&index=0&id=987a9ad2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987a9ad2')) {
      api.createRecord('987a9ad2', component.options)
    } else {
      api.reload('987a9ad2', component.options)
    }
    module.hot.accept("./SquareWithIcon.vue?vue&type=template&id=987a9ad2", function () {
      api.rerender('987a9ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.vue"
export default component.exports